import { TramRounded } from "@mui/icons-material";
import { createReducer } from "redux-create-reducer";
import actions from "../actions";

const initialState = {
  users: [],
  page: 0,
  rowsPerPage: 25,
  count: 0,
  sort: "",
  sortdirection: "asc",
  userLoaded: false,
  usersLoading: false,
  saving: false,
  saveError: false,
  createUserLoading: false,
  createUserSuccess: false,
  createUserError: false,
  createUserErrorMessage: "",
  user: {},
  deactivationReasons: [],
};

const reducers = {
  [actions.GET_USER_LIST](state) {
    return {
      ...state,
      usersLoading: true,
    };
  },
  [actions.SET_USER_LIST](state, { payload }) {
    return {
      ...state,
      users: payload.users,
      count: payload.count,
      usersLoading: false,
      saving: false,
    };
  },
  [actions.SET_USERS_PAGE](state, { payload }) {
    return {
      ...state,
      page: payload.page,
    };
  },
  [actions.SET_USERS_PER_PAGE](state, { payload }) {
    return {
      ...state,
      rowsPerPage: payload.rowsPerPage,
    };
  },
  [actions.SET_USERS_SORT](state, { payload }) {
    let sortdirection = state.sortdirection;
    if (state.sort && state.sort !== payload.sort) {
      sortdirection = "asc";
    } else if (state.sort) {
      sortdirection = sortdirection === "asc" ? "desc" : "asc";
    }
    return {
      ...state,
      sort: payload.sort,
      sortdirection,
    };
  },
  [actions.CREATE_USER](state, { payload }) {
    return {
      ...state,
      saving: true,
      createUserLoading: true,
      createUserError: false,
      createUserErrorMessage: "",
    };
  },
  [actions.CREATE_USER_SUCCESS](state) {
    return {
      ...state,
      createUserLoading: false,
      createUserSuccess: true,
    };
  },
  [actions.CREATE_USER_FAIL](state, { payload }) {
    return {
      ...state,
      createUserLoading: false,
      createUserError: true,
      createUserErrorMessage: payload,
    };
  },
  [actions.RESET_CREATE_USER](state) {
    return {
      ...state,
      createUserSuccess: false,
      createUserError: false,
    };
  },
  [actions.GET_USER_DETAILS](state) {
    return {
      ...state,
      userLoaded: false,
    };
  },
  [actions.SET_USER_DETAILS](state, { payload }) {
    return {
      ...state,
      userLoaded: true,
      user: payload.user,
      saving: false,
    };
  },
  [actions.SET_USER_SAVE_ERROR](state) {
    return {
      ...state,
      saving: false,
      saveError: true,
    };
  },
  [actions.CLEAR_USER_SAVE_ERROR](state) {
    return {
      ...state,
      saveError: false,
    };
  },
  [actions.GET_USER_DEACTIVATION_REASONS_SUCCESS](state, { payload }) {
    return {
      ...state,
      deactivationReasons: payload,
    };
  },
};

export default createReducer(initialState, reducers);
